/**
 * 관리자 화면 모양. 디자인은 하지 않고 휴대폰과 컴퓨터에서 둘 다 읽히게만 한다(2026-11-04 대표님 "휴대폰에서도").
 * 표는 넓은 화면에서는 표, 좁은 화면(600px 아래)에서는 줄마다 카드처럼 쌓인다.
 */
export const wrap = { maxWidth: 960, margin: '0 auto', padding: '16px', fontFamily: 'system-ui, sans-serif', fontSize: 18, lineHeight: 1.6 } as const;

export const adminStyle = `
body { margin: 0; background: #fff; color: #111; }
.admin-nav { display: flex; flex-wrap: wrap; gap: 8px; padding: 12px 16px; border-bottom: 1px solid #ccd; font-family: system-ui, sans-serif; font-size: 18px; }
.admin-nav a { padding: 8px 14px; border-radius: 6px; color: #1f4ea8; text-decoration: none; border: 1px solid #1f4ea8; }
.admin-nav a[aria-current=page] { background: #1f4ea8; color: #fff; }
.admin-nav button { margin-left: auto; font-size: 18px; padding: 8px 14px; background: #fff; border: 1px solid #888; border-radius: 6px; }
.admin-table { width: 100%; border-collapse: collapse; margin: 8px 0 24px; }
.admin-table th, .admin-table td { text-align: left; padding: 8px; border-bottom: 1px solid #e3e3ea; vertical-align: top; }
.admin-table th { background: #f3f5fa; font-weight: 600; }
.admin-table tr.click { cursor: pointer; }
.admin-table tr.click:hover { background: #f7f9ff; }
.warn { color: #b00020; font-weight: 600; }
.muted { color: #666; }
.row { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin: 0 0 12px; }
.row select, .row input[type=search], .row input[type=date] { font-size: 18px; padding: 8px 10px; }
.box { border: 1px solid #ccd; border-radius: 8px; padding: 12px 16px; margin: 0 0 16px; }
.box h2 { font-size: 20px; margin: 0 0 8px; }
.kv { display: grid; grid-template-columns: 11em 1fr; gap: 4px 12px; }
@media (max-width: 600px) {
  .admin-table thead { display: none; }
  .admin-table, .admin-table tbody, .admin-table tr, .admin-table td { display: block; width: 100%; box-sizing: border-box; }
  .admin-table tr { border: 1px solid #ccd; border-radius: 8px; margin: 0 0 10px; padding: 6px 0; }
  .admin-table td { border: 0; padding: 2px 12px; }
  .admin-table td::before { content: attr(data-label); display: inline-block; min-width: 7em; color: #666; }
  .kv { grid-template-columns: 1fr; }
  .kv dt { color: #666; margin-top: 6px; }
}
`;
